import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getMandateId = (state) => state.mandateId;
export const getAmountInEur = (state) => state.amountInEur;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getMandateId,
    getAmountInEur,
};
